import { Box } from "@mui/material"
import { Suspense, lazy } from "react"
import Loader from "../../../../../../../../components/loader"

const AnswerList = lazy(() => import('./answerList').then(({ AnswerList }) => ({ default: AnswerList })))
const Answer = () => {
    return (
        <Box>
            <Suspense fallback={<Loader/>}>
                <AnswerList/>
            </Suspense>
        </Box>
    )
}

export { Answer }